import React, { createContext, useState, useContext } from "react";

interface GenerateSessionsActionContextType {
  elementId: any;
  setElementId: (elementId: any) => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
}

export const GenerateSessionsActionContext = createContext<GenerateSessionsActionContextType>({
  elementId: null,
  setElementId: () => {},
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
});

interface GenerateSessionsActionProviderProps {
  children: React.ReactNode;
}

export const GenerateSessionsActionProvider: React.FC<GenerateSessionsActionProviderProps> = ({
  children,
}) => {
  const [elementId, setElementId] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);

  const value = {
    elementId,
    setElementId,
    showModal,
    setShowModal,    
    backendFormErrors,
    setBackendFormErrors,
  };
  return (
    <GenerateSessionsActionContext.Provider value={value}>
      {children}
    </GenerateSessionsActionContext.Provider>
  );
};
